import { forwardRef, ReactNode, useImperativeHandle } from "react";
import { classNames } from 'primereact/utils';
import { Controller, FieldValues, useForm } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import SvgWarningIcon from "./SvgWarningIcon";


type PropTyps = {
    onSubmitHandler?: (FormData: FieldValues) => void;
};

export type FormRef = {
  submit: () => void;
};

function AddEmailForm(props: PropTyps, ref: React.Ref<FormRef>): ReactNode {

    const {
        onSubmitHandler = (FormData: FieldValues) => {}
    } = props;

    const {
        reset,
        control,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: { isRegular: true, email: '' },
        resolver: yupResolver(Yup.object().shape({
            email: Yup.string().email("Invalid email address. E.g. example@email.com").required("Email is required.")
        })),
    });

    useImperativeHandle(ref, () => {
        return {
            submit: handleSubmit((formData: FieldValues) => {
                onSubmitHandler(formData);
                reset()
            })
        };
    }, [handleSubmit, onSubmitHandler]);

    return (
        <form className="p-card p-4 transition-all bg-white">
            <div className="flex gap-2 align-items-">
                <span className="text-blue-500">
                    <SvgWarningIcon strokeWidth={1} />
                </span>
                <span className="text-base font-medium text-color">
                    Please enter your email address. We will use this address to send you your completed document for e-signature. Please check for any typos.
                </span>
            </div>
            <div className="mt-4 flex flex-column gap-2">
                <label htmlFor="email" className={classNames({"font-medium text-red-500": errors.email })}>
                    Email Address<span className="ml-1 text-red-300">*</span>
                </label>
                <Controller
                    name="email"
                    control={control}
                    render={({ field, fieldState }) => {
                        return (
                            <>
                                <InputText
                                    {...field}
                                    id="email"
                                    tooltip="Enter the email"
                                    tooltipOptions={{ position: "top", style: { maxWidth: "30vw" } }}
                                    onChange={(e) => {
                                        field.onChange(e.target.value)
                                    }}
                                    className={classNames({
                                        'p-invalid': fieldState.invalid,
                                        'text-red-500': fieldState.invalid,
                                    })} />
                                {
                                    fieldState.invalid ? (
                                        <small className="text-red-500">
                                            {fieldState.error?.message}
                                        </small>
                                    ) : null
                                }

                            </>
                        )
                    }}
                />
            </div>
        </form>
    )
}

export default forwardRef(AddEmailForm);